export const INITIAL_STEP = 0;
export const FAVORITES_STEP = 1;
export const RECENTS_AND_SUGGESTED_STEP = 2;
export const REPORTS_STEP = 3;
export const SETTINGS_STEP = 4;
export const NAVIGATION_COLOR_STEP = 5;
export const STILL_HAVE_QUESTIONS_STEP = 6;

export const NEW_NAVIGATION_ONBOARDING_TOTAL_STEPS = 6;

export const NEW_NAVIGATION_ONBOARDING_JOURNEY_MAX_VIEWS = 3;

export const NEW_NAVIGATION_ONBOARDING_JOURNEY_TRACK_EVENT = "New Experience Onborading Journey";
